import * as React from "react";

function SvgCleverTap(props, ref) {
  return (
    <svg
      id="CleverTap_svg__Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x={0}
      y={0}
      viewBox="0 0 170.8 62.7"
      xmlSpace="preserve"
      width="1em"
      height="1em"
      {...{ ...props, ref }}
    >
      <style>
        {".CleverTap_svg__st0{fill:#ef4444}.CleverTap_svg__st1{fill:#101727}"}
      </style>
      <g id="CleverTap_svg__Group_33006">
        <g id="CleverTap_svg__Group_28926">
          <g id="CleverTap_svg__Group_28782">
            <path
              id="CleverTap_svg__Path_35226"
              className="CleverTap_svg__st0"
              d="M33.8 62.7c-2.6 0-5.2-.3-7.7-.9-8.7-2-16.3-7.4-21-15C-4.7 31 .1 10.3 15.9.4c1.3-.8 2.9-.4 3.7.9.8 1.2.4 2.9-.9 3.7-13.2 8.3-17.3 25.7-9 39 4 6.4 10.3 10.9 17.6 12.6 7.3 1.7 15 .5 21.4-3.5 1.3-.8 2.9-.4 3.7.9.8 1.3.4 2.9-.9 3.7-5.3 3.3-11.5 5-17.7 5z"
            />
          </g>
          <g
            id="CleverTap_svg__Group_28783"
            transform="translate(54.483 48.419)"
          >
            <circle
              id="CleverTap_svg__Ellipse_248"
              className="CleverTap_svg__st0"
              cx={2.8}
              cy={2.8}
              r={2.8}
            />
          </g>
        </g>
        <g id="CleverTap_svg__Group_29002" transform="translate(24.058 15.823)">
          <path
            id="CleverTap_svg__Path_24206"
            className="CleverTap_svg__st1"
            d="M0 12C-.2 5.8 4.7.7 10.9.5h.6c3.9-.1 7.4 1.9 9.5 5.2l-3.7 2.2c-1.2-2-3.4-3.2-5.7-3.1-3.8-.2-7 2.7-7.2 6.5v.7c-.2 3.8 2.7 7 6.4 7.2h.7c2.3.1 4.5-1.1 5.7-3.1l3.7 2.2c-2 3.3-5.6 5.3-9.5 5.2-6.1.1-11.2-4.8-11.4-11V12z"
          />
          <path
            id="CleverTap_svg__Path_24207"
            className="CleverTap_svg__st1"
            d="M23.7 0h4.1v23h-4.1V0z"
          />
          <path
            id="CleverTap_svg__Path_24208"
            className="CleverTap_svg__st1"
            d="M39.3 19.7c1.4.1 2.7-.5 3.5-1.6l3.3 1.9c-1.6 2.2-4.2 3.5-6.9 3.4-5.3 0-8.6-3.6-8.6-8.3-.1-4.4 3.4-8.1 7.8-8.3h.6c4.7 0 8 3.7 8 8.3 0 .6-.1 1.1-.2 1.7H34.9c.6 2.1 2.3 2.9 4.4 2.9zm3.6-6.1c-.3-1.9-2-3.2-3.9-3.2-2-.1-3.8 1.2-4.1 3.2h8z"
          />
          <path
            id="CleverTap_svg__Path_24209"
            className="CleverTap_svg__st1"
            d="M64 7.2L58 23h-4.6l-6-15.7h4.5l3.8 11 3.8-11H64z"
          />
          <path
            id="CleverTap_svg__Path_24210"
            className="CleverTap_svg__st1"
            d="M73.1 19.7c1.4.1 2.7-.5 3.5-1.6l3.3 1.9c-1.6 2.2-4.2 3.5-6.9 3.4-5.3 0-8.6-3.6-8.6-8.3-.2-4.4 3.3-8.2 7.8-8.3h.6c4.7 0 8 3.7 8 8.3 0 .6-.1 1.1-.2 1.7H68.7c.6 2.1 2.3 2.9 4.4 2.9zm3.6-6.1c-.3-1.9-2-3.2-3.9-3.2-2-.1-3.8 1.2-4.1 3.2h8z"
          />
          <path
            id="CleverTap_svg__Path_24211"
            className="CleverTap_svg__st1"
            d="M110.8 5.1h-6V23h-4.3V5.1h-5.9V.9h16.2v4.2z"
          />
          <path
            id="CleverTap_svg__Path_24212"
            className="CleverTap_svg__st1"
            d="M126.2 7.2V23h-4.1v-1.9c-1.3 1.5-3.2 2.4-5.1 2.3-4.2 0-7.7-3.6-7.7-8.3s3.5-8.3 7.7-8.3c2-.1 3.9.8 5.1 2.3V7.2h4.1zm-4 7.9c.1-2.3-1.7-4.3-4-4.4h-.4c-2.3-.1-4.3 1.8-4.3 4.1v.3c-.1 2.3 1.7 4.3 4 4.4h.3c2.3.1 4.3-1.7 4.4-4.1v-.3z"
          />
          <path
            id="CleverTap_svg__Path_24213"
            className="CleverTap_svg__st1"
            d="M146.8 15.1c0 4.7-3.5 8.3-7.7 8.3-2 .1-3.9-.8-5.1-2.3v8.2h-4.1v-22h4.1v1.9c1.2-1.5 3.1-2.4 5.1-2.3 4.2-.1 7.7 3.5 7.7 8.2zm-4.1 0c.1-2.3-1.7-4.3-4-4.4h-.4c-2.3-.1-4.3 1.8-4.3 4.1v.3c-.1 2.3 1.7 4.3 4 4.4h.3c2.3.1 4.3-1.7 4.4-4.1v-.3z"
          />
          <path
            id="CleverTap_svg__Path_24214"
            className="CleverTap_svg__st1"
            d="M87.7 23h-4.1V6.8h5.6c3.6-.2 6.7 2.4 7 6l-4 .6c-.3-2.4-2-2.6-2.7-2.5h-1.8V23z"
          />
        </g>
      </g>
    </svg>
  );
}

export default React.forwardRef(SvgCleverTap);
